import { ENUM_ORDER_PROGRESS, ENUM_WORK_MODES } from './enum';

export const ROUTE_KEYS = {
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  APP: '',
  CREATE_PASSWORD: 'create-password/:token',
  COMPANY_DETAILS: 'company-details',
  CONFIRM_MAIL: 'confirm-mail',
  PERSONAL_INFORMATION: 'personal-information',
  REGISTER: 'register',
  RESET_PASSWORD: 'reset-password/:token',
  VERIFY_ACCOUNT: 'verify-account',
  MONTHLY_INSIGHT: 'monthly-insight',
  AUTH: 'auth',
  HOME: 'home',
  ROLE_ACCEPTED: 'role-accepted/:token',
  // GET STARTED
  GET_STARTED: 'get-started',
  VERIFICATION_PENDING: '/verification-pending',
  VERIFY_NEW_ACCOUNT_EMAIL: '/auth/register/verify-email/:token',
  PAYMENT: 'payment/:paymentSubRoute',
  PAYMENT_GENERAL: 'payment/general',
  ADD_PEOPLE: 'add-people',

  // GET STARTED ACTIONS
  GET_STARTED_ACTION: 'actions',
  ADD_YOUR_TEAM: 'add-your-team',
  BILLING_DETAILS: 'billing-details',
  TOP_UP_WALLET: 'top-up-wallet',
  ADD_BRANCH_ADDRESSES: 'add-branch-addresses',
  SET_OPERATING_DAYS: 'set-operating-days',
  ASSIGN_ADMIN: 'assign-admin',
  ADD_DEPARTMENT: 'add-department',
  ADD_BRAND: 'add-brand',

  DASHBOARD: 'dashboard',
  PEOPLE: 'people',
  ORDER: 'order',
  EVENTS: 'events',
  ORDERS: 'orders',
  //EVENTS
  EVENTS_DETAILS: 'event-details',
  ADD_YOUR_GUESTS: 'add-your-guests',
  VIEW_EVENTS_DETAILS: 'event-details/:id',

  SETTINGS: 'settings',
  FEEDBACK: 'feedback',
  SUPPORT: 'support',
  FAQ: 'support/faq',

  // PROFILE
  PROFILE: 'profile',
  EDIT_PROFILE: 'edit-profile',
  CREATE_NEW_PASSWORD: 'profile/create-new-password/:token',
  MANAGE_PROFILE_PASSWORD: 'profile/manage-password',
  CHANGE_EMAIL: 'change-email',
  NEW_EMAIL: 'new-email',
  VERIFY_EMAIL: 'verify-email/:token',
  // GIFT_MEMBERS
  GIFT_MEMBERS: 'gift-members',
  GIFT_MEMBERS_CONFIRM: 'confirm',
  GIFT_BULK_MEMBERS: 'people/gift-bulk-members',
  // ORDERS
  CHECKOUT: 'checkout',
  BASKET: 'basket',
  RESTAURANTS: 'restaurants',
  RESTAURANT: 'restaurants/:id',
  MEAL: 'meals/:id',
  GROUP_ORDER_DELIVERY_DETAILS: 'group-order-delivery-details',
  BULK_ORDER_DELIVERY_DETAILS: 'bulk-order-delivery-details',
  ORDER_DETAILS: '/orders/:id',
  GROUP_BASKET: '/orders/basket/group',
  BULK_BASKET: '/orders/basket/bulk',
  BATCH_BASKET: '/orders/basket/batch',
  BATCHED_ORDERS_BRANDS: '/orders/batched/brands'
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  USER_ID: 'id',
  EMAIL: 'email',
  PHONE_NUMBER: 'phone_number',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  ROLE: 'role',
  ACTIVE_COMPANY: 'active_company',
  COMPANY_LIST: 'company_list',
  STAFF_NUMBER: 'staff_number',
  SELECTED_PEOPLE: 'selected_People',
  NEW_USER_ID: 'new_user_id',
  NEW_USER_EMAIL: 'new_user_email',
  NEW_USER_PHONE_NUMBER: 'new_user_phone_number',
  ADMIN_SKIPPED: 'admin_skipped',
  COKITCHEN: 'cokitchen',
  ORDER: 'bulk_order',
  BATCH_ORDER: 'batch_order',
  GROUP_ORDER: 'group_order',
  CALCULATED_ORDER_ID: 'calculated_order_id',
  CALCULATED_ORDER: 'calculated_order',
  COMPANY_VERIFIED: 'company_verified'
};

export const ORDER_PROGRESS_STEPS = [
  [ENUM_ORDER_PROGRESS.PAYMENT_RECEIVED],
  [ENUM_ORDER_PROGRESS.PREPARING_YOUR_ORDER],
  [ENUM_ORDER_PROGRESS.AWAITING_RIDER, ENUM_ORDER_PROGRESS.ORDER_IN_TRANSIT],
  [ENUM_ORDER_PROGRESS.ORDER_COMPLETED]
];

export const MEMBER_CSV_FORMAT =
  'https://docs.google.com/spreadsheets/d/1PxFAdSW_LkfxiiYZi4ilj-59poT9gP2XJTyqQtAGU_0/export?format=xlsx';

export const EVENTS_CSV_FORMAT =
  'https://docs.google.com/spreadsheets/d/1v1MOyziwSQW34Xy812xU8_3vuKMD_p48/export?format=xlsx';

export const ORDER_PROGRESS_DESCRIPTION = {
  [ENUM_ORDER_PROGRESS.PAYMENT_RECEIVED]: 'Your payment has been confirmed',
  [ENUM_ORDER_PROGRESS.PREPARING_YOUR_ORDER]: 'Your order will be ready soon',
  [ENUM_ORDER_PROGRESS.AWAITING_RIDER]: 'Your order is due for delivery',
  [ENUM_ORDER_PROGRESS.ORDER_IN_TRANSIT]: 'Your order is on the way',
  [ENUM_ORDER_PROGRESS.READY_FOR_PICKUP]: 'Your order is ready',
  [ENUM_ORDER_PROGRESS.ORDER_COMPLETED]: 'Your order is completed'
};

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const addMembersKeys = {
  dob: 'dob',
  department: 'department_name'
};

export const QUICKEATS_BRAND_IDS = [
  '1c0c3598-fa0b-4f51-bab8-ed96bc186ff4',
  'af2229f2-0cab-4bda-b323-72ef7ccaa557',
  '3bd1905c-5a0b-4047-b78f-58673d9d4178',
  'a979c6fe-a3ae-435b-8493-149cf9b02dc5'
];

export const WORK_MODES = [
  { name: 'Onsite', id: ENUM_WORK_MODES.ONSITE },
  { name: 'Remote', id: ENUM_WORK_MODES.REMOTE }
];
